import React from 'react';
import DesktopFlightModalContentComponent from '@websky/core/src/DesktopFlight/components/DesktopFlightModalContent/DesktopFlightModalContent';
const DesktopFlightModalContent = props => {
    return React.createElement(DesktopFlightModalContentComponent, Object.assign({}, props, { sliderSettings: { dots: true } }));
};
export default DesktopFlightModalContent;
